<template>
    <div style="width: 70px" class="py-2">
        <div @click="dialog = true" class="prod-img">
            <EmbedSanityImage
                :selectedImage="item.img && item.img.selectedImage"
                :originalFilename="item.img.originalFilename"
                image-align="center"
                classes="ma-0"
                :alt="
                    item.img.alt && item.img.alt[$i18n.locale]
                        ? item.alt
                        : {
                              en: 'c3controls product',
                              es: 'c3controls product',
                          }
                "
                height="110"
                fit="fill"
            />
        </div>
        <v-dialog v-model="dialog" width="600" style="padding: 2rem">
            <v-card>
                <EmbedSanityImage
                    :selectedImage="item.img && item.img.selectedImage"
                    image-align="center"
                    classes="ma-0"
                    :alt="
                        item.img.alt && item.img.alt[$i18n.locale]
                            ? item.alt
                            : {
                                  en: 'c3controls product',
                                  es: 'c3controls product',
                              }
                    "
                    width="600"
                    fit="scale"
                />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import { interpolateDOLStartersSlug } from '~/util/dol-staters-helper'

export default {
    name: 'ColumnImage',
    components: {
        EmbedCloudinary2,
        EmbedSanityImage,
    },
    data() {
        return {
            dialog: false,
        }
    },
    props: {
        item: {
            type: Object,
            default: null,
        },
    },
    methods: {
        createPartNumberToSlug(pn) {
            return pn.replace('/', '_')
        },
        createProductLink(item) {
            if (item.parent) {
                const path = this.localePath({
                    name: 'products-slug',
                    params: {
                        slug: interpolateDOLStartersSlug(item.parent[this.$i18n.locale].current),
                    },
                })
                if (this.isCustomProduct) {
                    return `${path}/${item.pn}/?isCustom=${this.isCustomProduct.hash}`
                } else {
                    return `${path}/${item.pn}/`
                }
            } else {
                return ''
            }
        },
        handleClipboard() {
            navigator.clipboard.writeText(this.item.pn)
            this.hitSnackbar({ string: 'partNumberCopiedSuccessfully' }, null)
        },
    },
    computed: {
        ...mapState('customProducts', ['customProductList']),
        isCustomProduct() {
            return (
                this.customProductList.length > 0 &&
                this.customProductList.find((i) => {
                    return i.hash === this.item.hash
                })
            )
        },
    },
}
</script>

<style scoped>
.prod-img {
    cursor: zoom-in;
}
</style>
